import DOMPurify from "dompurify";

export default function sanitizeRichText(string) {
    if (typeof string !== 'string' || string.length === 0) return '';

    const preparedContent = string
        // Unescape quotes
        .replace(/\\"/g, '"')
        // Replace literal "\n" with <br> (excel export?)
        .replace(/\\n/g, '<br>');

    return DOMPurify.sanitize(preparedContent, {FORCE_BODY: true});
}
